import React from 'react';
import './index.css';

import Loader       from './components/Loader';
import Navbar       from './components/Navbar';
import Hero         from './components/Hero';
import About        from './components/About';
import Services     from './components/Services';
import WhyUs        from './components/WhyUs';
import Industries   from './components/Industries';
import Clients      from './components/Clients';
// import Testimonials from './components/Testimonials';
import FAQ          from './components/FAQ';
import Contact      from './components/Contact';
import Footer       from './components/Footer';
import FloatingButtons from './components/FloatingButtons';

function App() {
  return (
    <>
      <Loader />
      <Navbar />
      <main>
        <Hero />
        <About />
        <Services />
        <WhyUs />
        <Industries />
        <Clients />
       {/* // <Testimonials /> */}
        <FAQ />
        <Contact />
      </main>
      <Footer />
      <FloatingButtons />
    </>
  );
}

export default App;
